import type { ColorScheme } from '@cbhq/cds-common/core/theme';
import {
  CoinbaseAppPickerCommonApplication,
  CoinbaseAppPickerCommonCategory,
  CoinbaseAppPickerCommonSpotlight,
} from '@cbhq/identity-api-hooks/app-switcher/types';

import { Application, Category, SpotLight } from '../providers/Applications.types';

export function mapApiApplicationsToApplications(
  application: CoinbaseAppPickerCommonApplication,
  spectrum: ColorScheme,
): Application {
  const illustrationUrl = application.tileName
    ? `https://static-assets.coinbase.com/ui-infra/illustration/v1/pictogram/svg/${spectrum}/${application.tileName}.svg`
    : '';
  return {
    applicationId: application.applicationId ?? '',
    label: application.label ?? '',
    destinationUri: application.destinationUri ?? '',
    tileName: application.tileName ?? '',
    illustrationUrl,
    category: application.category ?? '',
    position: application.position ?? '',
    tileUrls: application.tileUrls ?? {},
    accessibilityLabel: application.accessibilityLabel ?? '',
    id: application.id ?? '',
    transferSession: application.transferSession ?? false,
  };
}

export function mapApiCategoriesToCategories(category: CoinbaseAppPickerCommonCategory): Category {
  return {
    identifier: category.identifier ?? '',
    label: category.label ?? '',
    position: category.position ?? '',
  };
}

export function mapApiSpotLightToSpotLight({
  spotLight,
  spectrum,
}: {
  spotLight: CoinbaseAppPickerCommonSpotlight;
  spectrum: ColorScheme;
}): SpotLight {
  const application = mapApiApplicationsToApplications(spotLight?.application ?? {}, spectrum);
  const description: string = spotLight?.description ?? '';

  return {
    application,
    description,
  };
}
